'use client'
// =============================================================================
// ToolList — widget TOOLS (right-panel) : "AVAILABLE TOOLS" — jamais appelé
// "Capabilities" (voir docs/architecture/command-center-ui.md, Modèle mental :
// ce mot est déjà pris par le Capability Registry desktop / MachineCapability,
// P7 — concept différent). Source : Jinx Registry via GET /api/jinxes
// (modules/ai/tools/registry.ts, exposé en lecture seule le 30 juillet 2026).
// =============================================================================
import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'

interface JinxLite { name: string; description: string }

export function ToolList() {
  const { data: session } = useSession()
  const [jinxes, setJinxes] = useState<JinxLite[] | null>(null)

  useEffect(() => {
    if (!session) return
    fetch('/api/jinxes')
      .then(r => (r.ok ? r.json() : null))
      .then(d => setJinxes(Array.isArray(d?.jinxes) ? d.jinxes : []))
      .catch(() => setJinxes([]))
  }, [session])

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 9, letterSpacing: '0.12em', color: 'rgba(255,255,255,0.2)', marginBottom: 6, fontFamily: 'var(--font-mono)' }}>
        AVAILABLE TOOLS
      </div>
      {jinxes === null ? (
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.15)', fontFamily: 'var(--font-mono)' }}>⟳ Chargement…</div>
      ) : jinxes.length === 0 ? (
        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.15)', fontFamily: 'var(--font-mono)' }}>Registre indisponible</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 220, overflowY: 'auto' }}>
          {jinxes.map(j => (
            <div key={j.name} title={j.description} style={{
              padding: '5px 8px', borderRadius: 6,
              background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.04)',
              fontFamily: 'var(--font-mono)',
            }}>
              <div style={{ fontSize: 10.5, color: 'rgba(255,255,255,0.6)' }}>{j.name}</div>
              <div style={{ fontSize: 8.5, color: 'rgba(255,255,255,0.25)', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {j.description}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
